import { Alert, Button, Modal, Table } from "antd"
import { formatDateTimeISO } from "../../../utils/date";
import { useGetInventoryUploadJobsQuery } from "../../../api/inventory/inventoryApi";
import { InventoryUploadJob } from "../../../api/inventory/InventoryUploadJob";

const columns = [
  {
    title: "Job ID",
    dataIndex: "Id",
    key: "Id",
  },
  {
    title: "Processed Started At",
    dataIndex: "ProcessedStartedAt",
    key: "ProcessedStartedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-"
  },
  {
    title: "Processed Finished At",
    dataIndex: "ProcessedFinishedAt",
    key: "ProcessedFinishedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-"
  },
  {
    title: "Row Count (if successful)",
    dataIndex: "RowCount",
    key: "RowCount"
  },
  {
    title: "Error Count",
    dataIndex: "Errors",
    key: "Errors",
    render: (v?: string[]) => v ? v.length : "-"
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
  },
  {
    title: "Action",
    key: "action",
    render: (_: any, obj: InventoryUploadJob) => {
      function onClickViewErr() {
        Modal.confirm({
          content: obj.Errors!!.map(err => <li>{err}</li>),
          width: 800
        })
      }
      return (
        <Button
          disabled={obj.Errors == null}
          onClick={onClickViewErr}
        >
          View Errors
        </Button>
      )
    }
  }

]

export default function UploadJobTable() {
  const { data, error, isFetching, refetch } = useGetInventoryUploadJobsQuery();

  const sData = data?.toSorted((a, b) =>
    b.ProcessedStartedAt.localeCompare(a.ProcessedStartedAt));
  return (
    <>
    <Button onClick={refetch} type="primary">Reload</Button>
    { error && <Alert type="error" message="Error loading data" /> }
    <Table
      loading={isFetching}
      dataSource={sData}
      columns={columns}
    />
    </>
  )
}
